// Iter 228 (Kamel) — Vitrine publique des excursions sur la page voyage :
// photos des lieux, jours et tarifs, pour donner envie aux futurs inscrits.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { quandLabel } from './ExcursionsBlock';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ExcursionsPublicSection = ({ destinationTexte, tripId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!destinationTexte) return;
    // Iter 700 — avec tripId : programme rattaché exactement à cette page (jamais le programme d'été sur le week-end de mai)
    axios.get(`${API}/excursions/public/${encodeURIComponent(destinationTexte)}${tripId ? `?trip_id=${encodeURIComponent(tripId)}` : ''}`)
      .then(r => { if (r.data.programme) setData(r.data); })
      .catch(() => {});
  }, [destinationTexte, tripId]);

  if (!data || !data.excursions.length) return null;
  return (
    <div className="max-w-5xl mx-auto px-4 my-10" data-testid="excursions-public-section">
      <h2 className="text-lg md:text-xl font-bold text-[#1E3A5F] mb-1">🎡 Les excursions sur place</h2>
      <p className="text-sm text-gray-600 mb-4">Proposées chaque semaine pendant le séjour — réservation et tarifs détaillés dans votre Espace Adhérent après inscription.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.excursions.map(e => (
          <div key={e.id} className="bg-white rounded-xl shadow border border-gray-100 overflow-hidden" data-testid={`excursion-public-${e.id}`}>
            {(e.photos || [])[0] && (
              <img src={e.photos[0]} alt={e.nom} loading="lazy" className="w-full h-36 object-cover" />
            )}
            <div className="p-3">
              <p className="text-sm font-bold text-[#1E3A5F]">{e.nom}</p>
              <p className="text-[11px] text-gray-500">{quandLabel(e)}{e.heure_depart ? ` · départ ${e.heure_depart}` : ''}</p>
              {e.description && <p className="text-[11px] text-gray-600 mt-1 line-clamp-2">{e.description}</p>}
              <p className="text-[11px] font-bold text-emerald-700 mt-1">
                {e.tarif_plein}€{e.tarif_reduit > 0 ? ` / ${e.tarif_reduit}€ (${e.condition_reduit})` : ''}
              </p>
              {e.album_url && (
                <a href={e.album_url} target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold text-blue-700 underline">📸 Voir l'album photos</a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExcursionsPublicSection;
